module.exports = __webpack_public_path__ + "img/red.2b96f8b2.png";